import React from 'react';
import {
  HomeOutlined,
  ShoppingOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  SettingOutlined,
  AppstoreOutlined,
  CopyOutlined,
  EnvironmentOutlined,
  GiftOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';

export const menuItems: MenuProps['items'] = [
  {
    key: 'dashboard',
    icon: <HomeOutlined />,
    label: '首页',
  },
  {
    key: 'product-management',
    icon: <ShoppingOutlined />,
    label: '产品管理',
    children: [
      {
        key: 'products',
        icon: <ShoppingOutlined />,
        label: '产品列表',
      },
      {
        key: 'duplicate-products',
        icon: <CopyOutlined />,
        label: '重复卡对比',
      },
      {
        key: 'regional-recommendations',
        icon: <EnvironmentOutlined />,
        label: '地区推荐',
      },
      {
        key: 'external-products',
        icon: <AppstoreOutlined />,
        label: '分类',
      },
    ],
  },
  {
    key: 'orders',
    icon: <ShoppingCartOutlined />,
    label: '订单管理',
  },
  {
    key: 'content',
    icon: <FileTextOutlined />,
    label: '内容管理',
  },
  {
    key: 'operations-management',
    icon: <GiftOutlined />,
    label: '运营管理',
    children: [
      {
        key: 'marketing',
        icon: <AppstoreOutlined />,
        label: '首页配置',
      },
      {
        key: 'lottery',
        icon: <GiftOutlined />,
        label: '抽奖活动',
      },
    ],
  },
  {
    key: 'users',
    icon: <UserOutlined />,
    label: '用户管理',
  },
  {
    key: 'settings',
    icon: <SettingOutlined />,
    label: '系统设置',
  },
]; 
